<script>
export default {
  name: "DeviceLinkReportTable",
  props: {
    deviceReport: Object
  },
  render(h) {
    return h("div", { ref: "container" });
  },
  mounted() {
    this.buildDetailView(this.deviceReport);
  },
  updated() {
    this.buildDetailView(this.deviceReport);
  },
  methods: {
    buildDetailView() {
      let detail = this.deviceReport;
      if (detail === undefined || detail === null) {
        this.$refs.container.innerHTML = "No data";
        return;
      }
      function isArray(a) {
        return !!a && a.constructor === Array;
      }
      function isObject(a) {
        return !!a && a.constructor === Object;
      }
      function humanize(text) {
        text = text[0].toUpperCase() + text.slice(1);
        text = text.replace(/_/g, " ");
        return text;
      }

      const dateFormat = Intl.DateTimeFormat(undefined, {
        dateStyle: "full",
        timeStyle: "long"
      });

      const excludes = [
        "created_by_id",
        "group_id",
        "organization_id",
        "device_id",
        "report_id",
        "session_id",
        "hostname",
        "product_name",
        "started",
        "disable_on_done"
      ];

      // TODO This makes a lot of assumptions about the shape of the data and may only apply to MacBook
      detail = detail.report;
      detail.device_link_serial = detail.device_link_serial;
      detail.software_version = detail.software_version;
      detail.station = detail.station;

      for (let i = 0; i < detail.sequence.task_sequence.length; ++i) {
        let seconds = detail.sequence.task_sequence[i].duration;
        detail.sequence.task_sequence[i].duration = new Date(seconds * 1000)
          .toISOString()
          .slice(11, 19);
      }
      detail.errors = {
        device_error: detail.sequence.device_error,
        soft_error: detail.sequence.soft_error || ""
      };

      if (detail.sequence.hasOwnProperty("name")) {
        detail["sequence:_" + detail.sequence.name.replaceAll(" ", "_")] =
          detail.sequence.task_sequence;
        delete detail.sequence;
      } else {
        detail.sequence = detail.sequence.task_sequence;
      }

      detail.session = detail.session;
      delete detail.session.device_class;

      function addSubTable(root, anArray) {
        // Assumes that value is an array of homogenous objects
        // and those objects each have only atomic fields as members
        if (anArray.length === 0) return;

        var tr = document.createElement("tr");
        root.append(tr);
        var td = document.createElement("td");
        td.setAttribute("colspan", "2");
        tr.append(td);

        var table = document.createElement("table");
        table.classList.add("table", "table-sm");
        td.append(table);

        // Make a header row using the keys of the first object in the array
        var thead = document.createElement("thead");
        table.append(thead);
        var tr = document.createElement("tr");
        thead.append(tr);
        for (var k of Object.keys(anArray[0])) {
          if (excludes.includes(k)) continue;
          var th = document.createElement("th");
          th.innerText = humanize(k);
          tr.append(th);
        }

        // Make a row using the values of each object
        var tbody = document.createElement("tbody");
        table.append(tbody);
        for (var v of anArray) {
          if (isObject(v)) {
            var tr = document.createElement("tr");
            tbody.append(tr);
            for (var k of Object.keys(v)) {
              if (excludes.includes(k)) continue;
              var td = document.createElement("td");
              tr.append(td);
              td.innerText = v[k];
            }
          } else {
            console.error("Array Value, expected an object", v);
          }
        }
      }

      function addField(tbody, k, v) {
        if (excludes.includes(k)) return;
        var tdKey = document.createElement("td");
        tdKey.classList.add("table-secondary");

        tdKey.innerText = humanize(k);
        var tdValue = document.createElement("td");

        if (k === "created_at") {
          let d = new Date(v + "Z");
          tdValue.innerText = dateFormat.format(d);
        } else {
          tdValue.innerText = v;
        }

        var tr = document.createElement("tr");
        tr.append(tdKey);
        tr.append(tdValue);
        tbody.append(tr);
      }

      function addHeader(tbody, k) {
        var td = document.createElement("td");
        td.setAttribute("colspan", "2");
        td.classList.add("table-secondary", "pt-2");
        td.innerHTML = `<strong>${humanize(k)}</strong>`;
        var tr = document.createElement("tr");
        tr.append(td);
        tbody.append(tr);
      }

      function populateTable(root, anObject) {
        var values = {};
        var objects = {};
        var arrays = {};

        // Sort by by keys and bin by value type
        var keys = Object.keys(anObject);
        keys.sort();

        for (var i = 0; i < keys.length; ++i) {
          var k = keys[i];
          var v = anObject[k];

          if (isArray(v)) {
            arrays[k] = v;
          } else if (isObject(v)) {
            objects[k] = v;
          } else {
            values[k] = v;
          }
        }

        // Atomic value: add a row with two columns
        for (var k of Object.keys(values)) {
          var v = values[k];
          addField(root, k, v);
        }

        // Object value: add a header then call recursively with value
        for (var k of Object.keys(objects)) {
          var v = objects[k];
          addHeader(root, k);
          populateTable(root, v);
        }

        // Array value: add a header followed by a sub-table
        for (var k of Object.keys(arrays)) {
          var v = arrays[k];
          addHeader(root, k);
          addSubTable(root, v);
        }
      }

      function createTable(anObject) {
        var table = document.createElement("table");
        table.classList.add("table", "table-sm", "table-bordered");
        var tbody = document.createElement("tbody");
        table.append(tbody);
        populateTable(tbody, anObject);
        return table;
      }

      this.$refs.container.innerHTML = createTable(detail).outerHTML;
    }
  }
};
</script>
